import { render, staticRenderFns } from "./procesoTable.vue?vue&type=template&id=29061958&"
import script from "./procesoTable.vue?vue&type=script&lang=js&"
export * from "./procesoTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports